<template>
  <div class="mainWrap">
    <div class="main_root" :style="{width: width}">
      <div class="nav">
        <div class="icon">
          <div class="backBtn" @click="back_step" v-if="isShow">
            <v-icon name="regular/arrow-alt-circle-left" scale="1.5"></v-icon>
          </div>
        </div>
        <slot name="nav"></slot>
      </div>
      <div class="main">
        <slot name="main"></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Main",
    props: {
      width: {
        type: String,
        default: "890px"
      },
      isShow:{
        type: Boolean,
        default: true
      }
    },
    components: {
      "v-icon": () => import("vue-awesome/components/Icon"),
    },
    methods: {
      back_step() {
        // this.$router.go(-1);
        this.$emit("back");
      }
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .mainWrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .main_root {
    /*width: 890px;*/
    height: 710px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .nav, .main {
      width: 100%;
      display: flex;
      color: $color_white;
    }
    .nav {
      height: 60px;
      user-select: none;
      background-color: $block_bg_color_base;
      .icon {
        padding: 0 15px 0 20px;
        display: flex;
        align-items: center;
        .backBtn {
          display: flex;
          cursor: pointer;
        }
      }
    }
    .main {
      height: 620px;
    }
  }
</style>